import React, { ButtonHTMLAttributes } from 'react';
import './RequestAQuoteButton.scss';

interface RequestAQuoteButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  onClick: () => void
}

export const RequestAQuoteButton: React.FC<RequestAQuoteButtonProps> = ({ onClick, ...rest }) => {
  return (
    <div className="row mb-3">
      <button
        className="request-a-quote-btn btn-block m-0"
        type="button"
        aria-label="Request a quote"
        onClick={onClick}
        {...rest}
      >
        <span className="fa fa-file-text fa-lg mr-2 rounded-sm" aria-hidden="true"></span>
        <span className="btn-label">
          Grotere afname? Offerte aanvragen
        </span>
      </button>
    </div>
  );
};
